import { ComponentPropsWithRef } from "react";

export const VideoSyncIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M18.1131 19.8806L13.1165 14.8841C12.9573 14.7249 12.9573 14.4659 13.1165 14.3067L18.1131 9.31019C18.2723 9.15099 18.5312 9.15099 18.6904 9.31019L19.7622 10.382C19.9214 10.5413 19.9214 10.8002 19.7622 10.9594L16.4149 14.3067C16.2557 14.4659 16.2557 14.7249 16.4149 14.8841L19.7622 18.2314C19.9214 18.3906 19.9214 18.6495 19.7622 18.8087L18.6904 19.8806C18.5312 20.0398 18.2723 20.0398 18.1131 19.8806Z"
      fill="currentColor"
    />
    <path
      d="M13.0932 19.4817H2.83124C2.60556 19.4817 2.42303 19.2992 2.42303 19.0735V10.1371C2.42303 9.91144 2.60556 9.72891 2.83124 9.72891H13.0932C13.3188 9.72891 13.5014 9.91144 13.5014 10.1371V11.6533C13.5014 11.879 13.3188 12.0616 13.0932 12.0616H5.16389C4.93821 12.0616 4.75568 12.2441 4.75568 12.4698V16.7409C4.75568 16.9665 4.93821 17.1491 5.16389 17.1491H13.0932C13.3188 17.1491 13.5014 17.3316 13.5014 17.5573V19.0735C13.5014 19.2992 13.3188 19.4817 13.0932 19.4817Z"
      fill="currentColor"
    />
    <path
      d="M4.36497 8.72994C1.95826 8.72994 0 6.77168 0 4.36497C0 1.95826 1.95768 0 4.36497 0C6.77227 0 8.72995 1.95826 8.72995 4.36497C8.72995 6.77168 6.77168 8.72994 4.36497 8.72994ZM4.36497 2.33265C3.24413 2.33265 2.33265 3.24413 2.33265 4.36497C2.33265 5.48581 3.24413 6.39729 4.36497 6.39729C5.48581 6.39729 6.39729 5.48581 6.39729 4.36497C6.39729 3.24413 5.48581 2.33265 4.36497 2.33265Z"
      fill="currentColor"
    />
    <path
      d="M12.7357 8.72994C10.329 8.72994 8.37072 6.77168 8.37072 4.36497C8.37072 1.95826 10.329 0 12.7357 0C15.1424 0 17.1007 1.95826 17.1007 4.36497C17.1007 6.77168 15.1424 8.72994 12.7357 8.72994ZM12.7357 2.33265C11.6149 2.33265 10.7034 3.24413 10.7034 4.36497C10.7034 5.48581 11.6149 6.39729 12.7357 6.39729C13.8565 6.39729 14.768 5.48581 14.768 4.36497C14.768 3.24413 13.8565 2.33265 12.7357 2.33265Z"
      fill="currentColor"
    />
  </svg>
);
